import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../lib/api'
import { competitionIsOpen, competitionStatusLabel } from '../lib/competitionStatus'

type Competition = { id: number, slug: string, title: string, closesAt: string, status: string }

export default function Home() {
  const [competitions, setCompetitions] = useState<Competition[]>([])
  const [loading, setLoading] = useState(true)
  const [err, setErr] = useState<string>('')
  const openCompetitions = competitions.filter(c => competitionIsOpen(c.status, c.closesAt))

  useEffect(() => {
    api<{competitions: Competition[]}>('/api/public/competitions')
      .then(d => {
        setCompetitions(Array.isArray(d?.competitions) ? d.competitions : [])
      })
      .catch(e => setErr(e.message))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div className="card">
      <h2 style={{marginTop:0}}>Competitions</h2>
      {err && <p className='error-text'>{err}</p>}
      {loading ? (
        <p><small className="muted">Loading…</small></p>
      ) : openCompetitions.length === 0 ? (
        <p><small className="muted">No competitions are open right now.</small></p>
      ) : (
        <div style={{display:'grid', gap: 10}}>
          {openCompetitions.map(c => {
            const isOpen = competitionIsOpen(c.status, c.closesAt)
            return (
            <div key={c.id} className="card" style={{background:'#0b1220'}}>
              <div className="row" style={{justifyContent:'space-between'}}>
                <div>
                  <div style={{fontWeight:700}}>{c.title}</div>
                  <div className="row" style={{marginTop:6}}>
                    <span className="badge">{competitionStatusLabel(c.status)}</span>
                    <small className="muted">Closes: {new Date(c.closesAt).toLocaleString()}</small>
                  </div>
                </div>
                <div className="row">
                  {isOpen && <Link to={`/c/${c.slug}`} className="button-link">Submit</Link>}
                </div>
              </div>
            </div>
          )})}
        </div>
      )}
      <hr />
      <p><small className="muted">Judges should use the personal judging link they received.</small></p>
    </div>
  )
}
